import auth from "@/services/ExerciseInitAuth";

const loadPlans = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}nu_exams/plans_admin/`, {
    params: query
  });

const loadOrders = query =>
  auth.get(`${process.env.VUE_APP_EXERCISE_API}nu_exams/orders_admin/`, {
    params: query
  });

// Plans

const createPlan = plan =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}nu_exams/plans_admin/`, plan);

const putPlan = (id, plan) =>
  auth.put(`${process.env.VUE_APP_EXERCISE_API}nu_exams/plans_admin/${id}/`, plan);

const removePlan = id =>
  auth.delete(`${process.env.VUE_APP_EXERCISE_API}nu_exams/plans_admin/${id}/`);

export default {
  loadPlans,
  loadOrders,
  createPlan,
  putPlan,
  removePlan,
};
